export default __webpack_public_path__ + "static/media/pic3.3275b9e6.jpg";